import { setUtilsCustomConfig } from '@vas2t-lowcode/utils';
import { ElMessage } from 'element-plus';
import 'element-plus/es/components/message/style/css';
export function configUtils() {
  // 配置utils
  setUtilsCustomConfig({
    timeMin4Sentry: 3e3,
    timeMax4Sentry: 5e3,
    elMessage: ElMessage,
  });
}
